// Welcome.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import logo from '../wisdom.png'; // Update the path to your logo
import StatusPedimentoCard from './StatusPedimentoCard';
import CustomerTrafficReferenceCard from './CustomerTrafficReferenceCard';
import StatusModulationCard from './StatusModulationCard';
import ContainerTypeDistributionCard from './ContainerTypeDistributionCard';
import TrafficReferenceTimeSeriesCard from './TrafficReferenceTimeSeriesCard ';
import CombinedTrafficReferenceTimeSeriesCard from './CombinedTrafficReferenceTimeSeriesCard';
import ShipmentArrivalCalendar from './ShipmentArrivalCalendar';
// Import the card components

function Welcome() {
  const navigate = useNavigate();

  // You can add event handlers and other functions here if needed

  return (
    <div className="flex flex-col h-screen bg-gray-100">
      <nav className="flex justify-between items-center px-6 py-4 bg-white shadow">
        <div className="flex items-center">
          <img src={logo} alt="Wisdom logo" className="h-12 mr-2" />
          <span className="text-xl font-semibold text-gray-700"></span>
        </div>
      </nav>

      <div className="flex-grow overflow-auto">
        <header className="px-6 py-8">
          <h1 className="text-3xl font-bold text-gray-700 mb-4">Overview</h1>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-2">
            {/* Cards in a responsive grid */}
            <div><StatusPedimentoCard /></div>
            <div><CustomerTrafficReferenceCard /></div>
            <div><StatusModulationCard /></div>
            <div><ContainerTypeDistributionCard /></div>
            <div><TrafficReferenceTimeSeriesCard /></div>
            <div><CombinedTrafficReferenceTimeSeriesCard /></div>
            <div><ShipmentArrivalCalendar /></div>

          </div>
        </header>

      </div>

    </div>
  );
}

export default Welcome;
